module.exports = __webpack_public_path__ + "static/media/portfolio.25b47187.png";